import { all, call, fork, put, take } from "redux-saga/effects";
import { toast } from "react-toastify";

import { deleteInventoryApi, addInventory } from "../../apiService";
import { parseError } from "../../utils";

import {
  INVENTORY,
  FAIL,
  START,
  SUCCESS,
  DELETE_ITEM,
  CREATE_ITEM,
} from "../common";

function* deleteInventory() {
  while (true) {
    const { payload } = yield take(INVENTORY + DELETE_ITEM + START);
    try {
      yield call(deleteInventoryApi, payload);
      yield put({ type: INVENTORY + DELETE_ITEM + SUCCESS, payload });
      toast.success("Inventory has been deleted successfully");
    } catch (error) {
      toast.error(parseError(error));
      yield put({
        type: INVENTORY + DELETE_ITEM + FAIL,
        payload: parseError(error),
      });
    }
  }
}

function* createInventory() {
  while (true) {
    const { payload } = yield take(INVENTORY + CREATE_ITEM + START);
    try {
      yield call(addInventory, payload);
      toast.success("Inventory has been added successfully");
      yield put({ type: INVENTORY + CREATE_ITEM + SUCCESS, payload });
    } catch (error) {
      toast.error(parseError(error));
      yield put({
        type: INVENTORY + CREATE_ITEM + FAIL,
        payload: parseError(error),
      });
    }
  }
}

export function* inventorySagas() {
  yield all([fork(deleteInventory), fork(createInventory)]);
}
